import React, { useContext } from "react";
import ReactMapGL from "react-map-gl";
import { State } from "../context/State";
import { plotLayer } from "./util";

const API_KEY =
  "pk.eyJ1IjoiZHJld3dldGgiLCJhIjoiY2s2OWx0ZXNlMGg4bDNtcG9qdzVmZHhhcSJ9.aYQAQSmwf5XsRLkhZu9wlQ";

export const MapView = () => {
  const { layers, metaLookup, setView, view, mapTheme, mapRef } = useContext(
    State
  );

  const setViewport = viewport => setView(viewport);
  const renderThis = layers.map((l, i) => {
    return plotLayer({ l, i, metaLookup });
  });

  return (
    <ReactMapGL
      // ref={mapRef}
      ref={ref => (mapRef.current = ref)}
      transitionDuration={100}
      mapStyle={mapTheme}
      mapboxApiAccessToken={API_KEY}
      width={"100%"}
      height={"100%"}
      {...view}
      onViewportChange={setViewport}
    >
      {renderThis}
    </ReactMapGL>
  );
};
